import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";

export const apiCall = (command, otherData = {}, timeout) => {
  return new Promise((resolve, reject) => {
    const c2f = utils.cookie.get("currentAuth");
    if (c2f) {
      ajax
        .call({
          timeout,
          data: {
            command: command,
            c2f,
            ...otherData,
          },
        })
        .then((resp) => {
          const xml = new DOMParser().parseFromString(resp, "text/xml");
          const result = utils.xmlToJson(xml);
          resolve(result);
        })
        .fail((err) => {
          console.log(err);
          reject(err);
        });
    } else {
      reject({ message: "Not logged in" });
    }
  });
};

export const getManageShareListing = (data = {}) => {
  return new Promise((resolve, reject) => {
    apiCall("manageShares", {
      random: Math.random(),
      ...data,
    })
      .then(function (msg) {
        resolve(msg);
      })
      .catch(function (err) {
        reject(err);
      });
  });
};

export const deleteManageShareItems = (data = {}) => {
  return new Promise((resolve, reject) => {
    apiCall("deleteTempAccount", {
      random: Math.random(),
      ...data,
    })
      .then(function (msg) {
        resolve(msg);
      })
      .catch(function (err) {
        reject(err);
      });
  });
};

export const editManageShareItem = (data = {}) => {
  return new Promise((resolve, reject) => {
    apiCall("editTempAccount", {
      random: Math.random(),
      ...data,
    })
      .then(function (msg) {
        resolve(msg);
      })
      .catch(function (err) {
        reject(err);
      });
  });
};
